module.exports = [{
      plugin: require('/Users/tanay/Projects/turkbox/turkbox-website/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-169380360-1"},
    },{
      plugin: require('/Users/tanay/Projects/turkbox/turkbox-website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
